// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"5496357a","133":"a2b4cf00","302":"afc771ab","986":"0e5ebe86"}[chunkId] + ".chunk.js";
};